import React from "react";
import { StyledSection, StyledCard } from "./styles";
import { Headline } from "@components/Headline";
import { GithubIcon, LinkIcon, GooglePlayIcon } from "@components/Icons";
import { PROJECTS } from "./constants";

const IconLink = ({ Icon, link, type }) => {
  return (
    <a
      className="icon-link"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={type}
    >
      <Icon size={20} />
    </a>
  );
};

const Card = ({ project }) => {
  const { name, links, description, tags, img } = project;

  return (
    <StyledCard>
      <div className="head">
        {img ? (
          <img className="blur" src={img} alt={`${name} Photo`} />
        ) : (
          <div className="img-placeholder blur" />
        )}
      </div>
      <div className="body">
        <div>
          <div className="title">
            <span>{name}</span>
          </div>
          <p className="desc">{description}</p>
        </div>
        <div>
          <div className="links-container">
            {links.official && (
              <IconLink Icon={LinkIcon} link={links.official} type="app link" />
            )}
            {links.github && (
              <IconLink Icon={GithubIcon} link={links.github} type="github" />
            )}
            {links.googleapp && (
              <IconLink
                Icon={GooglePlayIcon}
                link={links.googleapp}
                type="google play store"
              />
            )}
          </div>
          <p className="tags">{tags.join(", ")}</p>
        </div>
      </div>
    </StyledCard>
  );
};

const ProjectSection = ({ ...props }) => {
  return (
    <StyledSection {...props}>
      <div className="content">
        <Headline text="Projects" />
        <div className="cards">
          {PROJECTS.map((project, index) => (
            <Card key={`project-${index}`} project={project} />
          ))}
        </div>
      </div>
    </StyledSection>
  );
};

export default ProjectSection;
